import NoPastComments from "Assets/Icons/NoPastCommentsIcon";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import StudentCommentListingBox from "Pages/StudentPortfolio/StudentCommentSection/StudentCommentListingBox";
import CommentInterface from "utilFunctions/CommonInterfaces/commentInterface";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const AllCommentsListing = ({
  commentArray,
  isCommentLoader,
  mode,
  CommentEditToggle,
  lopActionList,
  lopReasonList,
}: any) => {
  const { screen }: any = useWindowSize();
  return (
    <div
      className={
        ["xxl", "xl", "lg"].includes(screen) ? "w-100 mt-4" : "pt-6 mb-6"
      }
    >
      {commentArray && commentArray.length > 0
        ? commentArray.map((comment: CommentInterface, index: number) => {
            console.log(comment, index);
            return (
              <StudentCommentListingBox
                key={index}
                comment={comment}
                mode={mode}
                CommentEditToggle={CommentEditToggle}
                lopActionList={lopActionList}
                lopReasonList={lopReasonList}
              />
            );
          })
        : !isCommentLoader && (
            <NoResultFoundSearch primaryMessage={"No past comments"}>
              <NoPastComments />
            </NoResultFoundSearch>
          )}
    </div>
  );
};
export default AllCommentsListing;
